import React, { useState, useEffect } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import {
  appConstantes,
  limitSize,
  nemonicoEstadoDeshabilitar,
  nemonicoIdentificacion,
} from "../../constantes/appConstantes";
import { obtenerCantones, obtenerParroquias } from "../../sliceRedux/Reserva.slice";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { setCalendarLanguage } from "../../helpers/locale";
import { SelectButton } from "primereact/selectbutton";
import { CounterString } from "../../componentes/CounterString";
import ModalSocios from "./ModalSocios";
import {
  guardarOficialCumplimiento,
  obtenerNombres,
  obtenerOficialCumplimiento,
  obtenerSocio,
  setDatos,
  setDatosSocio,
  setMessageError,
  setMessageSuccess,
  setNombres,
} from "../../sliceRedux/ValidarReserva.slice";
import moment from "moment";
import Observation from "../../componentes/Observation";

const RegistrarOficial = (props) => {
  const {
    showLoader,
    hideLoader,
    dispatch,
    stepperRef,
    codSolConstitucion,
    toast,
    nemEstado,
    fecReunionAsamblea,
  } = props;
  const messageSuccess = useSelector((state) => state.validar.messageSuccess);
  const messageError = useSelector((state) => state.validar.messageError);
  const listaProvincias = useSelector((state) => state.reserva.listaProvincias);
  const listaCantones = useSelector((state) => state.reserva.listaCantones);
  const listaParroquias = useSelector((state) => state.reserva.listaParroquias);
  const listaTiposIdentificacion = useSelector((state) => state.reserva.listaTiposIdentificacion);
  const datosSocio = useSelector((state) => state.validar.datosSocio);
  const datosOficial = useSelector((state) => state.validar.datos);
  const [modal, setModal] = useState(false);
  const [deshabilitarCampos, setDeshabilitarCampos] = useState(false);
  const [deshabilitarBotones, setDeshabilitarBotones] = useState(false);
  const nombres = useSelector((state) => state.validar.nombres);

  const options = [
    { nemonico: true, descripcion: "Si" },
    { nemonico: false, descripcion: "No" },
  ];
  setCalendarLanguage("es");
  useEffect(() => {
    showLoader();
    dispatch(obtenerOficialCumplimiento(codSolConstitucion));
  }, []);

  useEffect(() => {
    return () => {
      hideLoader();
    };
  }, [listaCantones]);

  useEffect(() => {
    return () => {
      hideLoader();
    };
  }, [listaParroquias]);

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const validationSchemaEntidad = Yup.object().shape({
    provincia: Yup.string().required("Campo requerido."),
    canton: Yup.string().required("Campo requerido."),
    parroquia: Yup.string().required("Campo requerido."),
    callePrincipal: Yup.string().required("Campo requerido."),
    calleSecundaria: Yup.string().required("Campo requerido."),
    fechaNombramiento: Yup.string().required("Campo requerido."),
    tipoIdentificacion: Yup.string().required("Campo requerido."),
    identificacion: Yup.string().required("Campo requerido."),
    nombres: Yup.string().required("Campo requerido."),
    email: Yup.string()
      .email("Formato de correo electrónico no válido.")
      .required("Campo requerido."),
    celular: Yup.string()
      .required("Campo requerido.")
      .matches(/^09\d{8}$/, "El número de celular debe empezar con 09 y tener 10 dígitos."),
  });

  const formik = useFormik({
    initialValues: {
      provincia: "",
      canton: "",
      parroquia: "",
      callePrincipal: "",
      calleSecundaria: "",
      numero: "",
      referencia: "",
      email: "",
      celular: "",
      tipoIdentificacion: "",
      identificacion: "",
      nombres: "",
      tipo: false,
      telefono: "",
      fechaNombramiento: moment(fecReunionAsamblea).toDate(),
      codSolConstSocios: null,
      nemonicoTipoIdentificacion: "",
      codSolConsOfiCump: null,
    },
    validationSchema: validationSchemaEntidad,
    onSubmit: (data) => {
      showLoader();
      let dataSend = {
        codSolConsOfiCump: data.codSolConsOfiCump,
        codSolConstitucion: codSolConstitucion,
        esSocio: data.tipo,
        codTipoIdentificacion: data.tipoIdentificacion,
        numIdentificacion: data.identificacion,
        nombres: data.nombres,
      };
      if (data.tipo) {
        dataSend = { ...dataSend, codSolConstSocio: data.codSolConstSocios };
      } else {
        dataSend = {
          ...dataSend,

          codProvincia: data.provincia,
          codCanton: data.canton,
          codParroquia: data.parroquia,
          fechaNombramiento: moment(data.fechaNombramiento).valueOf(),
          callePrincipal: data.callePrincipal,
          calleSecundaria: data.calleSecundaria,
          celular: data.celular,
          tlfFijo: data.telefono,
          email: data.email,
          txtNumero: data.numero,
          txtReferencia: data.referencia,
        };
      }
      dispatch(guardarOficialCumplimiento(dataSend));
    },
  });

  const isFormFieldValid = (name) => {
    const isValid = !!(formik.touched[name] && formik.errors[name]);
    return isValid;
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    if (datosSocio.code === 200) {
      let datoSocio = datosSocio?.object ?? {};
      dispatch(obtenerCantones(datoSocio.codAmbGeoProvincia));
      dispatch(obtenerParroquias(datoSocio.codAmbGeoCanton));
      formik.setFieldValue("tipo", true);
      formik.setFieldValue("codSolConstSocios", datoSocio.codSolConstSocios);
      formik.setFieldValue("codSolConsOfiCump", null);
      formik.setFieldValue("tipoIdentificacion", datoSocio.codCatTipoIdentificacion);
      formik.setFieldValue("identificacion", datoSocio.numIdentificacion);
      formik.setFieldValue("nombres", datoSocio.nombres ?? "");
      formik.setFieldValue("celular", datoSocio.numCelular);
      formik.setFieldValue("telefono", datoSocio.numTelefono ?? "");
      formik.setFieldValue("email", datoSocio.txtEmail);
      formik.setFieldValue("provincia", datoSocio.codAmbGeoProvincia);
      formik.setFieldValue("canton", datoSocio.codAmbGeoCanton);
      formik.setFieldValue("parroquia", datoSocio.codAmbGeoParroquia);
      formik.setFieldValue("callePrincipal", datoSocio.nomCallePrincipal);
      formik.setFieldValue("calleSecundaria", datoSocio.nomCalleSecundaria);
      formik.setFieldValue("numero", datoSocio.txtNumero ?? "");
      formik.setFieldValue("referencia", datoSocio.txtReferencia ?? "");
      setDeshabilitarCampos(true);
      modal && toggleModal();
    }

    return () => {
      hideLoader();
      dispatch(setDatosSocio({ ...datosSocio, ...{ code: 0 } }));
    };
  }, [datosSocio.code]);

  useEffect(() => {
    if (datosOficial.code === 200) {
      let datos = datosOficial?.object ?? {};
      if (datos.codSolConsOfiCump) {
        dispatch(obtenerCantones(datos.codProvincia));
        dispatch(obtenerParroquias(datos.codCanton));
        formik.setFieldValue("tipo", datos.esSocio === "S" ? true : false);
        formik.setFieldValue("codSolConstSocios", datos.codSolConstSocio);
        formik.setFieldValue("codSolConsOfiCump", datos.codSolConsOfiCump);
        formik.setFieldValue("tipoIdentificacion", datos.codTipoIdentificacion);
        formik.setFieldValue("identificacion", datos.numIdentificacion);
        formik.setFieldValue("nombres", datos.nombres ?? "");
        formik.setFieldValue("celular", datos.celular);
        formik.setFieldValue("telefono", datos.tlfFijo ?? "");
        formik.setFieldValue("email", datos.email);
        formik.setFieldValue("provincia", datos.codProvincia);
        formik.setFieldValue("canton", datos.codCanton);
        formik.setFieldValue("parroquia", datos.codParroquia);
        formik.setFieldValue("callePrincipal", datos.callePrincipal);
        formik.setFieldValue("calleSecundaria", datos.calleSecundaria);
        formik.setFieldValue("numero", datos.txtNumero ?? "");
        formik.setFieldValue("referencia", datos.txtReferencia ?? "");
        datos.esSocio === "S" && setDeshabilitarCampos(true);
        let estado = nemonicoEstadoDeshabilitar.includes(nemEstado) && !datos?.observacion;
        setDeshabilitarBotones(estado);
      }
    }

    return () => {
      hideLoader();
      dispatch(setDatos({ ...datosOficial, ...{ code: 0 } }));
    };
  }, [datosOficial.code]);

  useEffect(() => {
    if (nombres.code === 200) {
      formik.setFieldValue("nombres", nombres?.object?.nombreCompleto ?? "");
      hideLoader();
    }
    return () => {
      dispatch(setNombres({ ...nombres, ...{ code: 0 } }));
    };
  }, [nombres.code]);

  const callbackSelected = (rowData) => {
    showLoader();
    dispatch(obtenerSocio(rowData.codSolConstSocios));
  };

  useEffect(() => {
    if (messageSuccess != "") {
      RenderToast(toast, "success", "Éxito", messageSuccess);
      dispatch(obtenerOficialCumplimiento(codSolConstitucion));
    }
    return () => {
      dispatch(setMessageSuccess(""));
    };
  }, [messageSuccess]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  return (
    <>
      <div className="card">
        <Observation observationValue={datosOficial?.object?.observacion} />
        <Fieldset legend="Datos personales">
          <div className="grid">
            <div className="flex col-12 md:col-12 ">
              <label
                htmlFor="tipo"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Es socio:
              </label>
              <SelectButton
                id="tipo"
                name="tipo"
                value={formik.values.tipo}
                optionLabel="descripcion"
                optionValue="nemonico"
                allowEmpty={false}
                color="secondary"
                disabled={!!formik.values.codSolConsOfiCump}
                onChange={(e) => {
                  if (e.value === true) {
                    toggleModal();
                  } else {
                    setDeshabilitarCampos(false);
                    let codSolConsOfiCump = formik.values.codSolConsOfiCump;
                    formik.resetForm();
                    formik.setFieldValue("codSolConsOfiCump", codSolConsOfiCump);
                    formik.handleChange(e);
                  }
                }}
                className={classNames({
                  "p-invalid": isFormFieldValid("tipo"),
                })}
                options={options}
              />
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="tipoIdentificacion"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Tipo de identificación:
              </label>
              <div className="col">
                <Dropdown
                  id="tipoIdentificacion"
                  name="tipoIdentificacion"
                  optionLabel="nomCatalogo"
                  optionValue="codCatalogo"
                  placeholder="Seleccione un tipo de documento"
                  options={listaTiposIdentificacion?.object || []}
                  value={formik.values.tipoIdentificacion}
                  emptyMessage={appConstantes.SIN_DATOS}
                  disabled={deshabilitarCampos || formik.values.codSolConsOfiCump}
                  className={classNames({
                    "p-invalid": isFormFieldValid("tipoIdentificacion"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                    let tipo = listaTiposIdentificacion?.object?.find(
                      (item) => item.codCatalogo === e.value
                    );
                    formik.setFieldValue("nemonicoTipoIdentificacion", tipo?.nomNemonico ?? "");
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("tipoIdentificacion")}
              </div>
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="identificacion"
                className="mr-2"
                style={{ minWidth: "110px", textAlign: "left" }}
                required
              >
                Identificación:
              </label>
              <div className="col">
                <InputText
                  id="identificacion"
                  name="identificacion"
                  value={formik.values.identificacion}
                  placeholder="Digite su número de identificación"
                  autoComplete="off"
                  disabled={deshabilitarCampos || formik.values.codSolConsOfiCump}
                  maxLength={
                    formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA
                      ? 10
                      : 20
                  }
                  keyfilter={
                    formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA
                      ? "int"
                      : "alphanum"
                  }
                  className={classNames({
                    "p-invalid": isFormFieldValid("identificacion"),
                  })}
                  onChange={(e) => {
                    formik.setFieldValue("identificacion", e.target.value.toUpperCase());
                    if (
                      formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA &&
                      formik.values.identificacion.length > 0
                    ) {
                      formik.setFieldValue("nombres", "");
                    }
                  }}
                  onBlur={(e) => {
                    if (
                      formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA &&
                      formik.values.identificacion.length > 0
                    ) {
                      showLoader();
                      dispatch(obtenerNombres(formik.values.identificacion));
                    }
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("identificacion")}
              </div>
            </div>
            <div className="flex col-12 md:col-12 ">
              <label
                htmlFor="nombres"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Apellidos y nombres:
              </label>
              <div className="col">
                <InputText
                  id="nombres"
                  name="nombres"
                  value={formik.values.nombres}
                  autoComplete="off"
                  disabled={
                    deshabilitarCampos ||
                    formik.values.codSolConsOfiCump ||
                    formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA
                  }
                  className={classNames({
                    "p-invalid": isFormFieldValid("nombres"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("nombres")}
              </div>
            </div>

            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="fechaNombramiento"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Fecha de nombramiento:
              </label>
              <div className="col">
                <Calendar
                  id="fechaNombramiento"
                  name="fechaNombramiento"
                  value={formik.values.fechaNombramiento}
                  dateFormat="dd/mm/yy"
                  showIcon
                  disabled
                  className={classNames({
                    "p-invalid": isFormFieldValid("fechaNombramiento"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                  locale="es"
                />
                {getFormErrorMessage("fechaNombramiento")}
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="m-2"></div>
        <Fieldset legend="Contacto">
          <div className="grid">
            <div className="flex col-12 md:col-3 ">
              <label
                htmlFor="celular"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
                required
              >
                Celular:
              </label>
              <div className="col">
                <InputText
                  id="celular"
                  name="celular"
                  keyfilter="int"
                  maxLength={10}
                  autoComplete="off"
                  disabled={deshabilitarCampos}
                  value={formik.values.celular}
                  className={classNames({
                    "p-invalid": isFormFieldValid("celular"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("celular")}
              </div>
            </div>
            <div className="flex col-12 md:col-3 ">
              <label
                htmlFor="telefono"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
              >
                Teléfono fijo:
              </label>
              <InputText
                id="telefono"
                name="telefono"
                keyfilter="int"
                maxLength={10}
                autoComplete="off"
                disabled={deshabilitarCampos}
                value={formik.values.telefono}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
                style={{ width: "100%" }}
              />
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="email"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Correo electrónico:
              </label>
              <div className="col">
                <InputText
                  id="email"
                  name="email"
                  value={formik.values.email}
                  autoComplete="off"
                  disabled={deshabilitarCampos}
                  maxLength={100}
                  className={classNames({
                    "p-invalid": isFormFieldValid("email"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("email")}
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="m-2"></div>
        <Fieldset legend="Domicilio">
          <div className="grid">
            <div className="col-12 md:col-4">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="provincia"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Provincia:
                </label>
                <div className="col">
                  <Dropdown
                    id="provincia"
                    name="provincia"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formik.values.provincia}
                    options={listaProvincias}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    disabled={deshabilitarCampos}
                    className={classNames({
                      "p-invalid": isFormFieldValid("provincia"),
                    })}
                    onChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue("canton", "");
                      formik.setFieldValue("parroquia", "");
                      showLoader();
                      dispatch(obtenerCantones(e.value));
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("provincia")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="canton"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Cantón:
                </label>
                <div className="col">
                  <Dropdown
                    id="canton"
                    name="canton"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formik.values.canton}
                    options={listaCantones}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    disabled={deshabilitarCampos}
                    className={classNames({
                      "p-invalid": isFormFieldValid("canton"),
                    })}
                    onChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue("parroquia", "");
                      showLoader();
                      dispatch(obtenerParroquias(e.value));
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("canton")}
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Parroquia:
                </label>
                <div className="col">
                  <Dropdown
                    id="parroquia"
                    name="parroquia"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formik.values.parroquia}
                    options={listaParroquias}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    disabled={deshabilitarCampos}
                    className={classNames({
                      "p-invalid": isFormFieldValid("parroquia"),
                    })}
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("parroquia")}
                </div>
              </div>
            </div>
            <div className="col-12 md:col-8">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="callePrincipal"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Calle principal:
                </label>
                <div className="col">
                  <InputTextarea
                    id="callePrincipal"
                    name="callePrincipal"
                    value={formik.values.callePrincipal}
                    autoComplete="off"
                    disabled={deshabilitarCampos}
                    rows={2}
                    className={classNames({
                      "p-invalid": isFormFieldValid("callePrincipal"),
                    })}
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("callePrincipal")}
                  <CounterString
                    length={formik.values.callePrincipal.length}
                    maxLength={limitSize.TEXT_INPUT_DEFECTO}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="calleSecundaria"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Calle secundaria:
                </label>
                <div className="col">
                  <InputTextarea
                    id="calleSecundaria"
                    name="calleSecundaria"
                    value={formik.values.calleSecundaria}
                    autoComplete="off"
                    disabled={deshabilitarCampos}
                    rows={2}
                    className={classNames({
                      "p-invalid": isFormFieldValid("calleSecundaria"),
                    })}
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("calleSecundaria")}
                  <CounterString
                    length={formik.values.calleSecundaria.length}
                    maxLength={limitSize.TEXT_INPUT_DEFECTO}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-6 ">
                <label
                  htmlFor="numero"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                >
                  Número:
                </label>
                <div className="col">
                  <InputText
                    id="numero"
                    name="numero"
                    value={formik.values.numero}
                    autoComplete="off"
                    disabled={deshabilitarCampos}
                    maxLength={10}
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="referencia"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                >
                  Referencia:
                </label>
                <div className="col">
                  <InputTextarea
                    id="referencia"
                    name="referencia"
                    disabled={deshabilitarCampos}
                    rows={2}
                    maxLength={limitSize.TEXT_AREA}
                    value={formik.values.referencia}
                    autoComplete="off"
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                  <CounterString
                    length={formik.values.referencia.length}
                    maxLength={limitSize.TEXT_AREA}
                  />
                </div>
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="flex pt-4 justify-content-between">
          <div>
            <Button
              type="button"
              label="Guardar"
              onClick={formik.handleSubmit}
              disabled={deshabilitarBotones}
              icon="pi pi-save"
              className="mr-2"
            />
            <Button
              type="button"
              label="Limpiar"
              onClick={() => {
                formik.resetForm();
                setDeshabilitarCampos(false);
              }}
              disabled={deshabilitarBotones}
              icon="pi pi-refresh"
              className="mr-2"
            />
          </div>
          <div>
            <Button
              label="Anterior"
              severity="secondary"
              type="button"
              icon="pi pi-arrow-left"
              className="mr-2"
              onClick={() => stepperRef.current.prevCallback()}
            />
            <Button
              label="Continuar"
              icon="pi pi-arrow-right"
              iconPos="right"
              type="button"
              severity="warning"
              disabled={!formik.values.codSolConsOfiCump}
              onClick={() => stepperRef.current.nextCallback()}
            />
          </div>
        </div>
      </div>
      {modal && (
        <ModalSocios
          modal={modal}
          callbackModal={toggleModal}
          showLoader={showLoader}
          hideLoader={hideLoader}
          dispatch={dispatch}
          callbackSelected={callbackSelected}
          codSolConstitucion={codSolConstitucion}
          toast={toast}
          selectedSocios={[]}
        />
      )}
    </>
  );
};
export default RegistrarOficial;
